import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { useToast } from '@/components/ui/toast';
import { useMe, useUpdateMe } from '@/features/settings/hooks';

const MIN = 0;
const MAX = 20;
const DEFAULT = 5;

export function ToleranceSlider() {
  const meQuery = useMe();
  const update = useUpdateMe();
  const toast = useToast();
  const [value, setValue] = useState<number>(DEFAULT);

  useEffect(() => {
    const remote = meQuery.data?.preferences?.fiscalTolerancePct;
    if (typeof remote === 'number') setValue(remote);
  }, [meQuery.data]);

  const clamp = (n: number) => Math.max(MIN, Math.min(MAX, n));

  const handleSave = async () => {
    try {
      await update.mutateAsync({ preferences: { fiscalTolerancePct: value } });
      toast.show({
        title: 'Tolerância atualizada.',
        description: `Novas conferências usarão ${value}% como limite.`,
        variant: 'success',
      });
    } catch (err) {
      toast.show({
        title: 'Erro ao salvar',
        description: err instanceof Error ? err.message : 'Tente novamente.',
        variant: 'error',
      });
    }
  };

  return (
    <Card>
      <div className="flex flex-col gap-3">
        <div>
          <h3 className="font-semibold">Tolerância de conferência</h3>
          <p className="text-sm text-(--color-fg-muted)">
            Diferença máxima entre produção calculada e o relatório do serviço.
            Padrão {DEFAULT}%. Acima do valor definido, a conferência marca DIVERGENTE.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-4">
          <input
            type="range"
            min={MIN}
            max={MAX}
            step={1}
            value={value}
            onChange={(e) => setValue(clamp(Number(e.target.value)))}
            className="flex-1 min-w-[180px] accent-(--color-accent)"
            aria-label="Tolerância em porcentagem"
          />
          <div className="flex items-center gap-2">
            <Input
              type="number"
              min={MIN}
              max={MAX}
              step={1}
              value={value}
              onChange={(e) => setValue(clamp(Number(e.target.value || 0)))}
              className="w-20"
            />
            <span className="text-sm text-(--color-fg-muted)">%</span>
          </div>
        </div>
        <div className="flex justify-end">
          <Button onClick={handleSave} disabled={update.isPending}>
            {update.isPending ? 'Salvando…' : 'Salvar tolerância'}
          </Button>
        </div>
      </div>
    </Card>
  );
}
